import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowUp from "@core/__generated__/icon/figma/arrow-up.svg";
export default createSvgComponent(ArrowUp);